// Parses SUMMARY.md into a flat list of { type, ... } items that the sidebar
// renders. Supported item types:
//   { type: 'section', title: 'Introduction' }
//   { type: 'link', label, path, depth }  // path is relative to docs root, e.g. "workbench/README.md"

const LINK_RE = /^(\s*)\*\s+\[([^\]]+)\]\(([^)]+)\)\s*$/;
const SECTION_RE = /^##\s+(.+?)\s*$/;

export function parseSummary(markdown) {
  const items = [];
  if (!markdown) return items;

  const lines = markdown.split(/\r?\n/);

  for (const line of lines) {
    const section = line.match(SECTION_RE);
    if (section) {
      items.push({ type: "section", title: section[1] });
      continue;
    }

    const link = line.match(LINK_RE);
    if (link) {
      const indent = link[1].length;
      // 2-space indent = 1 level of nesting
      const depth = Math.floor(indent / 2);
      items.push({
        type: "link",
        label: link[2],
        path: link[3].replace(/^\.\//, ""),
        depth,
      });
    }
  }

  return items;
}

// Given a docs-relative file path (e.g. "workbench/canvas-basics.md"),
// return the URL route under /docs (e.g. "/docs/workbench/canvas-basics").
export function pathToRoute(filePath) {
  let p = filePath.replace(/^\.\//, "").replace(/\.md$/i, "");
  // /README at end means it's the index page for that folder
  p = p.replace(/\/README$/i, "");
  if (p === "README" || p === "") return "/docs";
  return "/docs/" + p;
}

// Inverse: given a URL path (starting at /docs), return the docs-relative file
// path to fetch (e.g. "/docs/workbench" → "workbench/README.md").
export function routeToPath(urlPath) {
  let rel = urlPath.replace(/^\/docs\/?/, "");
  if (!rel) return "README.md";
  if (/\.md$/i.test(rel)) return rel;
  // Treat any bare path as a folder index first; the fetch layer can fall back.
  return rel + "/README.md";
}
